export const bakeryImage = require('./bakery.png');
export const beveragesImage = require('./beverages.png');
export const dairyCheeseImage = require('./dairy_cheese.png');
export const dipsaCondimentsImage = require('./dips_condiments.png');
export const frozenImage = require('./frozen.png');
export const kiranaGroceryImage = require('./kirana_grocery.png');
export const masalaSeasoningImage = require('./masala_seasonings.png');
export const oilGheeImage = require('./oil_ghee.png');
export const specialityProductImage = require('./speciality_products.png');
export const gravySauceImage = require('./gravy_sause_purees.png');